import { NormalizedCacheObject } from '@apollo/client';
import { makePreloadSlot } from '../../../UnicronApp/preloader/PreloadSlot';

export const HannibalSlot = makePreloadSlot('HANNIBAL_CACHE', (): NormalizedCacheObject => ({}));
